export default class {
	idAta
	numeroAta

	constructor(idAta, numeroAta) {
		this.idAta = idAta
		this.numeroAta = numeroAta
	}
}
